// Closed enum of pedigree relationship-edge kinds (the context-menu targets).
//
// Dependency-free leaf module (no React imports) so both EdgeContextMenu.jsx
// and the Node vocabulary generator (scripts/va-vocab/generate.js) can import
// it without pulling in DOM/MUI code.
export const EDGE_KINDS = ['child', 'sibling-group', 'spouse-line'];
